import { Invoice } from "./typesDefinition";

export function isInvoice(invoice: unknown): invoice is Invoice {
  return (invoice as Invoice).__typename === "Invoice";
}

export function invoicesComparator(i1: Invoice, i2: Invoice): number {
  return (i1.invoiceNumber || "").localeCompare(i2.invoiceNumber || "");
}
